import { render, staticRenderFns } from "./TheVisaNotesList.vue?vue&type=template&id=09680f10&"
import script from "./TheVisaNotesList.vue?vue&type=script&lang=js&"
export * from "./TheVisaNotesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports